import { Property } from "csstype";
import { styled } from "styled-components";

import { Div } from "../Div";

export interface RowProps {
  $noGutters?: boolean;
  $align?: Property.AlignItems;
  $justify?: Property.JustifyContent;
  $wrap?: boolean;

  $gap?: number;
}

export const Row = styled(Div)<RowProps>`
  ${({ $noGutters = false }) => ($noGutters ? "" : `margin-right: 16px;`)};

  ${({ $gap, theme }) => ($gap ? `gap:  ${theme.size($gap)};` : "")};

  display: flex;
  flex-wrap: ${({ $wrap = true }) => ($wrap ? "wrap" : "nowrap")};
  justify-content: ${({ $justify }) => $justify};
  align-items: ${({ $align }) => $align};
`;
